import React from "react"

const SparkleIcon = () => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" aria-hidden="true">
    <path
      d="M8.5 0L9.8 6.2L16 7.5L9.8 8.8L8.5 15L7.2 8.8L1 7.5L7.2 6.2L8.5 0Z"
      fill="#9e7e43"
    />
    <path
      d="M13.5 1L14.1 3.6L16.7 4.2L14.1 4.8L13.5 7.4L12.9 4.8L10.3 4.2L12.9 3.6L13.5 1Z"
      fill="#9e7e43"
    />
  </svg>
)

type Props = {
  label: string
  className?: string
}

const LandingSparkleBadge: React.FC<Props> = ({ label, className = "" }) => (
  <div
    className={`inline-flex w-fit items-center gap-2 rounded-xl bg-[rgba(158,126,67,0.1)] px-3 py-1 ${className}`.trim()}
  >
    <SparkleIcon />
    <span className="font-dm-sans text-xs font-bold uppercase tracking-[1.2px] text-[#9e7e43]">
      {label}
    </span>
  </div>
)

export default LandingSparkleBadge
